export default __webpack_public_path__ + "static/media/introduction_person.746b3a2e.svg";